import { Text } from '@mercator-gcp/grout';
import AIMarker from 'components/elements/AIMarker';
import { EmptyField } from 'components/elements/EmptyField';
import { humanReadableArea } from 'utils/format';
import { isNumber } from 'utils/validate';
import type { ProjectSize } from 'types';

type TProps = {
  minBuildableSqft?: ProjectSize['maxbuildable_sqft_min'];
  maxBuildableSqft?: ProjectSize['maxbuildable_sqft_max'];
};

const BuildableSqft = ({ minBuildableSqft, maxBuildableSqft }: TProps) => {
  if (
    !isNumber(minBuildableSqft) ||
    !isNumber(maxBuildableSqft) ||
    maxBuildableSqft === 0
  ) {
    return <EmptyField />;
  }

  const generateLabel = (min: number, max: number) => {
    if (min === max) {
      return `${humanReadableArea(max)}`;
    }

    return `${humanReadableArea(min)} - ${humanReadableArea(max)}`;
  };

  return (
    <AIMarker>
      <Text>{generateLabel(minBuildableSqft || 0, maxBuildableSqft || 0)}</Text>
    </AIMarker>
  );
};

export default BuildableSqft;
